import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import PressStrip from "@/components/landing/PressStrip";
import Pillars from "@/components/landing/Pillars";
import AuthorBio from "@/components/landing/AuthorBio";
import TableOfContents from "@/components/landing/TableOfContents";
import Testimonials from "@/components/landing/Testimonials";
import Results from "@/components/landing/Results";
import Audiobook from "@/components/landing/Audiobook";
import QuizCTA from "@/components/landing/QuizCTA";
import MemberReviews from "@/components/landing/MemberReviews";
import PressMention from "@/components/landing/PressMention";
import UpcomingEvent from "@/components/landing/UpcomingEvent";
import Blog from "@/components/landing/Blog";
import Pricing from "@/components/landing/Pricing";
import CartaDocente from "@/components/landing/CartaDocente";
import Newsletter from "@/components/landing/Newsletter";
import Contact from "@/components/landing/Contact";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import ExitIntentPopup from "@/components/landing/ExitIntentPopup";
import StickyPurchaseBar from "@/components/landing/StickyPurchaseBar";
import CookieConsent from "@/components/landing/CookieConsent";
import ChatWidget from "@/components/chat/ChatWidget";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page-root"
      className="min-h-screen bg-[#F9F8F6] text-[#0B192C] selection:bg-[#0B192C] selection:text-[#F9F8F6]"
    >
      <Navbar />
      <Hero />
      <PressStrip />
      <Pillars />
      <AuthorBio />
      <TableOfContents />
      <Testimonials />
      <UpcomingEvent />
      <PressMention />
      <MemberReviews />
      <Results />
      <Audiobook />
      <QuizCTA />
      <Blog />
      <Pricing />
      <CartaDocente />
      <Newsletter />
      <Contact />
      <Faq />
      <Footer />
      <WhatsAppFloat />
      <ExitIntentPopup />
      <StickyPurchaseBar />
      <CookieConsent />
      <ChatWidget persona="landing" position="bottom-left" />
    </main>
  );
}
